import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmotionalIntro } from '../components/EmotionalIntro';
import { BookContents } from '../components/BookContents';
import { DiasporaSection } from '../components/DiasporaSection';
import { BookExcerpts } from '../components/BookExcerpts';
import { WhyNowSection } from '../components/WhyNowSection';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-[#0a0a0a] overflow-x-hidden" data-id="element-243">
      <HeroSection data-id="element-244" />
      <EmotionalIntro data-id="element-245" />
      <BookContents data-id="element-246" />
      <DiasporaSection data-id="element-247" />
      <BookExcerpts data-id="element-248" />
      <WhyNowSection data-id="element-249" />
      <FinalCTA data-id="element-250" />
    </main>;
}